<template>
  <div class="infoService">
    <div class="row row2">
      <div class="item-box1">
        <div class="header">
          <span>学生端焦点图</span>
        </div>
        <div class="view">
          <input type="file" multiple accept=".jpg,.png,.jif" ref="imgUpload" @change="uploadFile3" v-show="1 != 1">
          <div class="inputBut">
            <p>请上传格式为.png/.jpg的图片，图片大小需小于500KB</p>
            <el-button class="uploadBut" @click="$refs.imgUpload.click()" size="small">上传</el-button>
          </div>
          <div class="imgView">
            <div class="imgInfo" v-for="(item, index) in imgList" :key="item.id">
              <img :src="item.content" alt="">
              <div class="removeButBox" @click="remove(item.id, index, 1)"><i class="el-icon-delete-solid"></i></div>
            </div>
          </div>
        </div>
      </div>
      <div class="item-box2">
        <div class="header">
          <span>字段查看权限设置</span>
        </div>
        <div class="view">
          <el-form label-width="100px" style="margin-top:10px">
            <el-form-item label="证件号码：">
              <el-row>
                <el-col :span="7">
                  省级管理员
                  <el-radio-group v-model="permissionForm.idNumber.province" @change="changeP">
                    <el-radio :label="1">开放</el-radio>
                    <el-radio :label="0">隐藏</el-radio>
                  </el-radio-group>
                </el-col>
                <el-col :span="9">
                  市级及合作单位管理员
                  <el-radio-group v-model="permissionForm.idNumber.examSite" @change="changeP">
                    <el-radio :label="1">开放</el-radio>
                    <el-radio :label="0">隐藏</el-radio>
                  </el-radio-group>
                </el-col>
                <el-col :span="8">
                  考点管理员
                  <el-radio-group v-model="permissionForm.idNumber.registerSite" @change="changeP">
                    <el-radio :label="1">开放</el-radio>
                    <el-radio :label="0">隐藏</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="手机号码：">
              <el-row>
                <el-col :span="7">
                  省级管理员
                  <el-radio-group v-model="permissionForm.phone.province" @change="changeP">
                    <el-radio :label="1">开放</el-radio>
                    <el-radio :label="0">隐藏</el-radio>
                  </el-radio-group>
                </el-col>
                <el-col :span="9">
                  市级及合作单位管理员
                  <el-radio-group v-model="permissionForm.phone.examSite" @change="changeP">
                    <el-radio :label="1">开放</el-radio>
                    <el-radio :label="0">隐藏</el-radio>
                  </el-radio-group>
                </el-col>
                <el-col :span="8">
                  考点管理员
                  <el-radio-group v-model="permissionForm.phone.registerSite" @change="changeP">
                    <el-radio :label="1">开放</el-radio>
                    <el-radio :label="0">隐藏</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
            </el-form-item>
            <!-- <el-form-item label="成绩分数：">
              <el-row>
                <el-col :span="7">
                  省级管理员
                  <el-radio-group v-model="permissionForm.score.province" @change="changeP">
                  <el-radio :label="1">开放</el-radio>
                  <el-radio :label="0">隐藏</el-radio>
                </el-radio-group>
                </el-col>
                <el-col :span="9">
                  考点(及副)管理员
                  <el-radio-group v-model="permissionForm.score.examSite" @change="changeP">
                  <el-radio :label="1">开放</el-radio>
                  <el-radio :label="0">隐藏</el-radio>
                </el-radio-group>
                </el-col>
                <el-col :span="8">
                  考点管理员
                  <el-radio-group v-model="permissionForm.score.registerSite" @change="changeP">
                  <el-radio :label="1">开放</el-radio>
                  <el-radio :label="0">隐藏</el-radio>
                </el-radio-group>
                </el-col>
              </el-row>
            </el-form-item> -->
          </el-form>
        </div>
      </div>
    </div>
    <div class="row instructions">
      <div class="header">
        <span>操作指南</span>
      </div>
      <div class="view">
        <input type="file" accept=".pdf" ref="pdfUpload" @change="uploadFile2" v-show="1 != 1">
        <div>
          <span>考点/报名点操作指南：</span>
          <div class="content">
            <div class="inputBut">
              <p>请上传考点/报名点操作指南（pdf文件）</p>
              <el-button class="uploadBut" @click="fileInputClick(1)" size="small">上传</el-button>
            </div>
            <div v-if="examFile" class="pdfBox pdfBox1">
              <p><i class="iconfont pro-icon-pdf"></i>考点/报名点操作指南</p>
              <div>
                <i class="removeBut el-icon-error" @click="removeFile(1)"></i>
              </div>
            </div>
          </div>
        </div>
        <div>
          <span>考生操作指南：</span>
          <div class="content">
            <div class="inputBut">
              <p>请上传考生操作指南（pdf文件）</p>
              <el-button class="uploadBut" @click="fileInputClick(2)" size="small">上传</el-button>
            </div>
            <div v-if="stuFile" class="pdfBox">
              <p><i class="iconfont pro-icon-pdf"></i>考生操作指南</p>
              <div>
                <i class="removeBut el-icon-error" @click="removeFile(2)"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row activitySet">
      <div class="header">
        <span>活动回顾设置</span>
      </div>
      <div class="view">
        <input type="file" accept=".jpg,.png,.jif" @change="uploadFile" ref="rightImgUpload" v-show="1 != 1">
        <div class="view-add" @click="initActivity"><i class="el-icon-plus"></i>添加</div>
        <div class="view-show" v-for="(item, i) in setList" :key="i">
          <div class="img">
            <img :src="item.activityPic" alt="">
            <div class="remove-but" @click="removeActivity(item.id)"> <i class="el-icon-delete-solid"></i> </div>
          </div>
          <div class="context">
            <p class="title">{{ item.activityTitle }}</p>
            <p class="href">{{ item.activityLink }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row instructions">
      <div class="header">
        <span>上传考试试听</span>
      </div>
      <div class="view">
        <audio @canplay="canplay" ref="audio" :src="haveDuration" />
        <input type="file" accept=".mp3" ref="mp3Upload" @change="uploadMp3" v-show="1 != 1">
        <div>
          <span>上传考试试听：</span>
          <div class="content">
            <div class="inputBut">
              <p>请上传考试试听文件（mp3文件）</p>
              <el-button :loading="loading" class="uploadBut" @click="fileUpMp3(1)" size="small">上传</el-button>
            </div>
            <div class="pdfBox pdfBox1" v-if="mp3audit.url != ''">
              <autioCate :name="true" width="180px" height="30px" :audioSrc="mp3audit" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog custom-class="dailogComponents" title="添加" :visible.sync="visible" :destroy-on-close="true"
      :close-on-click-modal="false" v-if="visible" width="460px">
      <div class="dialogBox">
        <div class="row">
          <div><span>*</span>活动图片：</div>
          <div class="img">
            <el-button @click="$refs.rightImgUpload.click();" class="uploadBut" size="small">上传</el-button>
            <div class="img-show" v-if="visibleObj.activityPic">·
              <img :src="visibleObj.activityPic" alt="">
              <div>
                <i class="el-icon-error" @click="visibleObj.activityPic = ''"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div><span>*</span>活动标题：</div>
          <div>
            <el-input placeholder="请输入活动标题" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="200"
              show-word-limit v-model="visibleObj.activityTitle" clearable></el-input>
          </div>
        </div>
        <div class="row">
          <div><span>*</span>活动链接：</div>
          <div>
            <el-input placeholder="请输入活动链接" v-model="visibleObj.activityLink" clearable></el-input>
          </div>
        </div>
        <el-row type="flex" justify="space-around">
          <el-button @click="visible = false">取消</el-button>
          <el-button @click="addActivity" type="primary">保存</el-button>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import autioCate from '../../components/autioCate.vue'
export default {
  components: { autioCate },
  data() {
    return {
      imgList: [], //学生焦点图
      setList: [], //右侧的设置list
      uploadIndex: 0, //右侧上传下标
      examFile: null,
      stuFile: null,
      fileUploadType: 1, //上传类型，1考点，2考生
      visible: false,
      visibleObj: {
        activityLink: "", //活动连接
        activityPic: "", //活动图片
        activityTitle: "", //活动标题
        id: "",
      },
      permissionForm: {
        idNumber: {
          examSite: null,
          province: null,
          registerSite: null,
        },
        phone: {
          examSite: null,
          province: null,
          registerSite: null,
        },
        score: {
          examSite: null,
          province: null,
          registerSite: null,
        },
      },
      loading: false,
      mp3File: { url: '' },
      mp3audit: { url: '' },
      haveDuration: "",
    };
  },
  mounted() {
    this.load();
    this.loadPdf();
    this.loadMp3();
    this.getFieldRoles();
  },
  methods: {
    fileUpMp3() {
      this.$refs.mp3Upload.click();
    },
    deleMp3() {

    },
    canplay() {
      this.mp3File.time = this.$refs.audio.duration
      this.$axios
        .post("/information/addAudition", this.mp3File)
        .then((res) => {
          let data = res.data;
          this.$message.success("试听文件设置成功！");
          this.loadMp3()
          this.loading = false
        }).catch(err => {
          this.loading = false
        })
    },
    uploadMp3(e) {
      this.loading = true
      let file = e.target.files[0];
      if (file.type != 'audio/mpeg') {
        this.$message.warning("只能上传mp3格式文件！");
        this.loading = false
        return
      }
      let formData = new FormData();
      formData.append("file", file);
      this.$axios
        .post("upload", formData)
        .then((res) => {
          let data = res.data.data;
          this.mp3File = data
          this.haveDuration = data.url
        }).catch(err => {
          this.loading = false
        })
    },
    changeP(val) {
      this.$axios
        .post("information/addFieldRoles", this.permissionForm)
        .then((res) => {
          this.$message.success("修改成功！");
          this.load();
        });
    },
    getFieldRoles() {
      this.showIdNumber = false;
      this.showPhone = false;
      this.showScore = false;
      this.$axios.get("information/queryFieldRoles").then((res) => {
        this.permissionForm = res.data.data;
        console.log(`res.data.data`, res.data.data);
      });
    },
    load() {
      this.$axios.post("information").then((res) => {
        let { systemActivityVOS, focus } = res.data.data;
        this.imgList = focus;
        this.setList = systemActivityVOS;
      });
    },
    loadPdf() {
      this.$axios.get("upload/getGuide?type=" + [3, 4, 6]).then((res) => {
        let { data } = res.data;
        let examFile = data.find((item) => item.roles == "3,4");
        let stuFile = data.find((item) => item.roles == "6");
        this.examFile = examFile ? examFile : null;
        this.stuFile = stuFile ? stuFile : null;
      });
    },
    loadMp3() {
      this.$axios.get("/information/queryAudition").then((res) => {
        let { data } = res.data
        if (data) {
          this.mp3audit = data
        }
      });
    },
    uploadFile(e) {
      let file = e.target.files[0];
      let formData = new FormData();
      formData.append("file", file);
      this.$axios.post("upload", formData).then((res) => {
        this.visibleObj.activityPic = res.data.data.url;
        this.$message.success("上传成功！");
        e.outerHTML = e.outerHTML; //可清空当前file之前添加的文件
        e.target.value = "";
      });
    },
    fileInputClick(type) {
      if ((this.examFile && type == 1) || (this.stuFile && type == 2)) {
        this.$message.warning("该角色已存在操作指南，请删除后再上传！");
        return;
      }
      this.fileUploadType = type;
      this.$refs.pdfUpload.click();
    },
    removeFile(type) {
      let submitId = type == 1 ? this.examFile.id : this.stuFile.id;
      this.$axios.delete("upload/deleteGuide/" + submitId).then((res) => {
        this.$message.success("删除成功！");
        if (type == 1) {
          this.examFile = null;
        } else {
          this.stuFile = null;
        }
      });
    },
    uploadFile2(e) {
      let submitType = this.fileUploadType == 1 ? [3, 4] : [6];
      let file = e.target.files[0];
      let formData = new FormData();
      formData.append("file", file);
      this.$axios
        .post("upload/addGuide?type=" + submitType, formData)
        .then((res) => {
          let { data, msg } = res.data;
          if (this.fileUploadType == 1) {
            this.examFile = data;
          } else {
            this.stuFile = data;
          }
          this.$message.success("上传成功！");
          e.outerHTML = e.outerHTML; //可清空当前file之前添加的文件
          e.target.value = "";
        });
    },
    uploadFile3(e) {
      let file = e.target.files;
      let formData = new FormData();
      for (let index = 0; index < file.length; index++) {
        formData.append("file", file[index]);
      }
      this.$axios.post("/information/uploadFocus", formData).then((res) => {
        e.outerHTML = e.outerHTML; //可清空当前file之前添加的文件
        e.target.value = "";
        this.$message.success("上传成功！");
        this.load();
      });
    },
    addRow() {
      this.setList.push({
        activityLink: "",
        activityPic: "",
        activityTitle: "",
        id: "",
      });
    },
    setSave(index) {
      let obj = this.setList[index];
      let { activityLink, activityPic, activityTitle } = obj;
      if (activityLink == "" || activityPic == "" || activityTitle == "") {
        this.$message.warning("数据未填写完整！");
        return;
      }
      this.$axios.post("information/addActivity", obj).then((res) => {
        this.$message.success("保存成功！");
        this.load();
      });
    },
    remove(id, index, type) {
      if (type == 1) {
        // left
      } else {
        // right
        if (!id) {
          this.setList.splice(index);
          return;
        }
      }
      this.$axios.delete("information/" + id).then((res) => {
        this.$message.success("删除成功！");
        this.load();
      });
    },
    removeActivity(id) {
      this.$axios.delete("information/" + id).then((res) => {
        this.$message.success("删除成功！");
        this.load();
      });
    },
    initActivity() {
      this.visibleObj = {
        activityLink: "", //活动连接
        activityPic: "", //活动图片
        activityTitle: "", //活动标题
        id: "",
      };
      this.visible = true;
    },
    addActivity() {
      if (
        this.visibleObj.activityLink == "" ||
        this.visibleObj.activityPic == "" ||
        this.visibleObj.activityTitle == ""
      ) {
        this.$message.warning("请填写完整数据再提交！");
        return;
      }
      this.$axios
        .post("information/addActivity", this.visibleObj)
        .then((res) => {
          this.$message.success("保存成功！");
          this.visible = false;
          this.load();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.infoService {
  min-width: 1400px;

  >.row {
    margin-bottom: 20px;

    .header {
      line-height: 1.5;
      padding: 10px 20px;
      border-bottom: 1px solid #f2f2f2;

      span {
        border-left: 2px solid #409eff;
        padding-left: 5px;
      }
    }

    border: 1px solid #f2f2f2;
  }

  .view {
    .inputBut {
      width: 240px;

      .el-button {
        width: 100px;
        margin: 20px 0px;
        border: 1px solid #409eff;
        color: #409eff;
      }
    }
  }

  .row2 {
    display: flex;

    .item-box1,
    .item-box2 {
      width: 50%;
    }

    .item-box1 {
      border-right: 1px solid #f2f2f2;

      .view {
        margin: 20px;
        padding: 10px;
        background-color: #f2f2f2;
        display: flex;

        .inputBut {
          p {
            font-size: 13px;
          }
        }

        .imgView {
          flex: 1;
          margin-left: 20px;
          display: flex;
          flex-wrap: nowrap;

          .imgInfo {
            width: 100px;
            height: 100px;
            overflow: hidden;
            margin: 10px;
            margin-left: 0px;

            img {
              width: 100px;
              height: 100px;
            }

            .removeButBox {
              width: 100%;
              cursor: pointer;
              font-size: 16px;
              font-weight: bold;
              text-align: center;
              background-color: rgba(0, 0, 0, 0.2);
              color: #f56c6c;
              transform: translateY(0px);
              transition: all 0.3s 0s linear;
            }
          }

          .imgInfo:hover {
            .removeButBox {
              transform: translateY(-25px);
            }
          }
        }
      }
    }

    .item-box2 {
      ::v-deep .el-form-item__label {
        font-weight: bold;
      }

      ::v-deep .el-radio-group {
        margin-left: 5px;
      }

      ::v-deep .el-form-item {
        margin-bottom: 10px;
      }

      ::v-deep .el-radio__label {
        padding-left: 5px;
      }

      ::v-deep .el-radio {
        margin-right: 5px;
      }
    }
  }

  .instructions {
    .view {
      display: flex;

      >div {
        display: flex;
        padding: 10px 20px;
        flex: 1;

        span {
          width: 200px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
      }

      .content {
        flex: 1;
        display: flex;
        background-color: #f2f2f2;
        padding: 10px;

        .inputBut {
          p {
            font-size: 13px;
          }
        }
      }

      .pdfBox {
        display: flex;
        overflow: hidden;
        border: 1px dashed #f2f2f2;
        padding: 20px;

        p {
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .removeBut {
          color: #f56c6c;
          font-size: 18px;
          cursor: pointer;
          transform: translateY(-50px);
          transition: all 0.3s 0s linear;
        }

        .iconfont {
          font-size: 30px;
        }
      }

      .pdfBox:hover {
        .removeBut {
          transform: translateY(0px);
        }
      }
    }
  }

  .activitySet {
    .view {
      display: flex;
      flex-wrap: wrap;

      >div {
        width: 200px;
        height: 200px;
        margin: 10px;
      }

      .view-add {
        background-color: #f2f2f2;
        display: flex;
        justify-content: center;
        align-content: center;
        flex-direction: column;
        text-align: center;
        color: #bfbfbf;
        font-size: 20px;
        font-weight: bold;
        cursor: pointer;

        i {
          font-size: 120px;
          font-weight: bold;
        }
      }

      .view-show {
        .img {
          position: relative;
          height: 50%;
          overflow: hidden;

          img {
            width: 100%;
          }

          .remove-but {
            position: absolute;
            top: -80px;
            right: -80px;
            width: 80px;
            height: 80px;
            text-align: center;
            background-color: #ff5353;
            color: #fff;
            transform: rotate(45deg);
            transition: all 0.25s 0s linear;
            display: flex;
            flex-direction: column-reverse;
            cursor: pointer;

            i {
              transform: rotate(-45deg);
              font-size: 20px;
              margin-bottom: 7px;
            }
          }
        }

        .context {
          height: calc(50% - 20px);
          padding: 10px 5px;
          overflow: auto;

          .title {
            margin-bottom: 10px;
          }

          .href {
            color: #409eff;
            text-decoration: underline;
            cursor: pointer;
          }
        }
      }

      .view-show:hover {
        .img {
          .remove-but {
            top: -40px;
            right: -40px;
          }
        }
      }
    }
  }

  .dialogBox {
    padding: 20px;

    .row {
      display: flex;
      margin-bottom: 20px;

      >div:nth-child(1) {
        width: 100px;

        >span {
          color: #f56c6c;
        }
      }

      >div:nth-child(2) {
        flex: 1;
      }

      .img {
        .img-show {
          width: 120px;
          height: 110px;
          overflow: hidden;
          display: flex;

          img {
            width: 100px;
            margin-top: 10px;
          }

          i {
            color: #f56c6c;
            font-size: 20px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
